import { FacebookErrorPipe } from "./pipes/facebook-error.pipe";
import { ComponentLoaderModule } from "./component-loader/component-loader.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";

// COMPONENTS
import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { NotificationSidebarComponent } from "./notification-sidebar/notification-sidebar.component";
import { CookieNoticeComponent } from "./notification-templates/cookie-notice/cookie-notice.component";
import { TosUpdateComponent } from "./notification-templates/tos-update/tos-update.component";

// DIRECTIVES
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { SidebarDirective } from "./directives/sidebar.directive";
import { SidebarLinkDirective } from "./directives/sidebarlink.directive";
import { SidebarListDirective } from "./directives/sidebarlist.directive";
import { SidebarAnchorToggleDirective } from "./directives/sidebaranchortoggle.directive";
import { SidebarToggleDirective } from "./directives/sidebartoggle.directive";
import { CustomPaginationComponent } from "./custom-pagination/custom-pagination.component";
import { NgxPaginationModule } from "ngx-pagination";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { CollapseExpandButtonComponent } from "./collapse-expand-button/collapse-expand-button.component";
import { AppStatusPipe } from "./pipes/app-status.pipe";
import { ChartboostErrorPipe } from "./pipes/chartboost-error.pipe";
import { FyberErrorPipe } from "./pipes/fyber-error.pipe";
import { UnityAdsErrorPipe } from "./pipes/unityads-error.pipe";
import { IronsourceErrorPipe } from "./pipes/ironsource-error.pipe";
import { AppPlatformPipe } from "./pipes/app-platform.pipe";
import { CountryCodesToNamesPipe } from "./pipes/country-codes-to-names.pipe";

@NgModule({
  exports: [
    CommonModule,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    NotificationSidebarComponent,
    ToggleFullscreenDirective,
    SidebarDirective,
    NgbModule,
    TranslateModule,
    TosUpdateComponent,
    CookieNoticeComponent,
    NgxPaginationModule,
    CustomPaginationComponent,
    AccordionModule,
    ComponentLoaderModule,
    CollapseExpandButtonComponent,
    FacebookErrorPipe,
    AppStatusPipe,
    ChartboostErrorPipe,
    FyberErrorPipe,
    UnityAdsErrorPipe,
    IronsourceErrorPipe,
    AppPlatformPipe,
    CountryCodesToNamesPipe,
  ],
  imports: [
    RouterModule,
    CommonModule,
    NgbModule,
    TranslateModule,
    PerfectScrollbarModule,
    NgxPaginationModule,
    AccordionModule.forRoot(),
    ComponentLoaderModule,
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    NotificationSidebarComponent,
    ToggleFullscreenDirective,
    SidebarDirective,
    SidebarLinkDirective,
    SidebarListDirective,
    SidebarAnchorToggleDirective,
    SidebarToggleDirective,
    TosUpdateComponent,
    CookieNoticeComponent,
    CustomPaginationComponent,
    CollapseExpandButtonComponent,
    FacebookErrorPipe,
    AppStatusPipe,
    ChartboostErrorPipe,
    FyberErrorPipe,
    UnityAdsErrorPipe,
    IronsourceErrorPipe,
    AppPlatformPipe,
    CountryCodesToNamesPipe,
  ],
})
export class SharedModule {}
